/**
 * 파일명 : usr0103p.jsx
 * 설명 : 사용자정보등록
 * 수정내역
 ************************************************
 * Version    수정일자      수정자    수정내용      
 ************************************************
 * 1.1       2024-03-13    기라성    학력정보 입학년월 추가   
 * 1.2       2024-04-12    기라성    주소 다음API로 등록하는 것으로 수정 
 */

/************************************************
 * Import 영역  
 ************************************************/
/************************************************
 * Import 영역
 ************************************************/
/* React */
import React from 'react';
import validator from 'validator';
import locale from 'antd/lib/locale/ko_KR';
import DaumPost from 'pages/components/DaumPost';

/* AntD */
import { Input, Layout, Row, Col, Space, Button, Descriptions, DatePicker, ConfigProvider, Switch, Collapse, Typography, Select, Upload, Table } from 'antd';
import { CaretRightOutlined, PlusOutlined, MinusOutlined, UploadOutlined } from '@ant-design/icons';

/* Reducer */
import { useAppSelector, useAppDispatch } from '../../../redux/hooks';
import { Usr0103p1Action } from '../../../redux/slice/usr/usr0103p1_slice';
import { IUserStCdState, IDeptCdState, IDutyCdState, IEduState, IEduTpState, IPostCdState, ICertState, ICertTpState } from '../../../redux/models/usr/usr0103p1_model';

/* 업무 */
import * as commonProxy from 'libs/CommonProxy';
import * as common from 'libs/common';
import * as commonDate from 'libs/commonDate';
import dayjs from 'dayjs';

/************************************************
 * 전역변수 선언영억
 ************************************************/
const Usr0103p1 = (props:any) => {
    /**
     * 기능 : State / Reducer 선언
     * param : 
     */
     const dispatch     = useAppDispatch();
     const mmbrItems    = useAppSelector((state) => state.Usr0103p1.mmbrItems);
     const deptCdList   = useAppSelector((state) => state.Usr0103p1.deptCdList);
     const dutyCdList   = useAppSelector((state) => state.Usr0103p1.dutyCdList);
     const postCdList   = useAppSelector((state) => state.Usr0103p1.postCdList);
     const userStCdList = useAppSelector((state) => state.Usr0103p1.userStCdList);
     const eduTpList    = useAppSelector((state) => state.Usr0103p1.eduTpList);
     const eduList      = useAppSelector((state) => state.Usr0103p1.eduList);
     const selectedEduRowKeys = useAppSelector((state) => state.Usr0103p1.selectedEduRowKeys);
     const certTpList    = useAppSelector((state) => state.Usr0103p1.certTpList);
     const certList      = useAppSelector((state) => state.Usr0103p1.certList);
     const selectedCertRowKeys = useAppSelector((state) => state.Usr0103p1.selectedCertRowKeys);
     const [addrType, setAddrType] = React.useState('');

    /************************************************
     * Render 변수 선언 및 셋팅영역
     ************************************************/
    let attachFileItem = {};

    /* AntD */
    const { Content } = Layout;
    const { Panel }   = Collapse;
    const { Text }    = Typography;
    const { Option }  = Select;
    const { Search }  = Input;

    /**
     * 기능 : fn_DeptCds
     * 설명 : 부서코드 콤보박스 데이터 조회
     * param : 
     * return : None
     **/
     const fn_DeptCds = () => {
        /* 변수선언 및 셋팅 영역 */
        // 입력파라미터
        const requestData = {
            deptStCd: 'A'
        };

        /* 트렌젝션 호출 및 결과 셋팅 */
        commonProxy.callAsyncSvc(requestData, {
            txCd: 'TRCOMR0005',
            success: (responseData:any) => {
                dispatch(Usr0103p1Action.setDeptCdList(responseData.deptItems));
            },
        });
    };

    const deptOptions = React.useCallback(() => {
        let arrOptions: IDeptCdState[] = [];
        deptCdList.forEach((item:IDeptCdState) => {
            arrOptions.push({
                label: item.deptNm,
                value: item.deptCd
            });
        });

        return arrOptions;
    }, [deptCdList]);


    const setDutyCdList = () => {
        const option = {
            useYn: 'Y',
            callback: (datas:IDutyCdState[]) => {
                let arrOptions:IDutyCdState[] = [];
                datas.forEach((item:IDutyCdState) => {
                    arrOptions.push({
                        label: item.cdNm,
                        value: item.cd
                    });
                });

                dispatch(Usr0103p1Action.setDutyCdList(arrOptions));
            }
        };
        common.getComCodeList('012', option);
    }


    const setEduTpList = () => {
        const option = {
            useYn: 'Y',
            callback: (datas:IEduTpState[]) => {
                let arrOptions:IEduTpState[] = [];
                datas.forEach((item:IEduTpState) => {
                    arrOptions.push({
                        label: item.cdNm,
                        value: item.cd
                    });
                });

                dispatch(Usr0103p1Action.setEduTpList(arrOptions));
            }
        };
        common.getComCodeList('022', option);
    }
    
    const setCertTpList = () => {
        const option = {
            useYn: 'Y',
            callback: (datas:ICertTpState[]) => {
                let arrOptions:ICertTpState[] = [];
                datas.forEach((item:ICertTpState) => {
                    arrOptions.push({
                        label: item.cdNm,
                        value: item.cd
                    });
                });

                dispatch(Usr0103p1Action.setCertTpList(arrOptions));
            }
        };
        common.getComCodeList('023', option);
    }

    const setPostCdList = () => {
        const option = {
            useYn: 'Y',
            callback: (datas:IPostCdState[]) => {
                let arrOptions:IPostCdState[] = [];
                datas.forEach((item:IPostCdState) => {
                    arrOptions.push({
                        label: item.cdNm,
                        value: item.cd
                    });
                });

                dispatch(Usr0103p1Action.setPostCdList(arrOptions));
            }
        };
        common.getComCodeList('011', option);
    }
    

    const setUserStCdList = () => {
        const option = {
            useYn: 'Y',
            callback: (datas:IUserStCdState[]) => {
                let arrOptions:IUserStCdState[] = [];
                datas.forEach((item:IUserStCdState) => {
                    arrOptions.push({
                        label: item.cdNm,
                        value: item.cd
                    });
                });

                dispatch(Usr0103p1Action.setUserStCdList(arrOptions));
            }
        };
        common.getComCodeList('003', option);
    }

    /* Table Columns */
    const eduColumns = React.useCallback(() => {
        const arr:any = [
            {
                title: () => <div style={{ textAlign: 'center' }}>학력</div>,
                dataIndex: 'eduTpCd',
                key: 'eduTpCd',
                align: 'center',
                width: 100,
                render: (_:string, record:IEduState, idx:number) => {
                    const handleChange = (item:string) => {
                        dispatch(Usr0103p1Action.setEduItem({...record, eduTpCd : item}));
                    }
    
                    const options = eduTpList.map(e => {
                        return (<Option key={e.value} value={e.value}>{e.label}</Option>);
                    });
                    return (
                        <Select disabled={!common.isAdmin()} style={{ width: 130 }} onChange={handleChange} value={record.eduTpCd}>{options}</Select>
                    )
                },
            },
            {
                title: () => <div style={{ textAlign: 'center' }}>입학년월</div>,
                dataIndex: 'entrYm',
                key: 'entrYm',
                align: 'center',
                width: 100,
                render: (_:string, record:IEduState, idx:number) => (
                    <ConfigProvider locale={locale}>
                        <DatePicker
                            picker='month'
                            format='YYYY-MM'
                            style={{ width: 100 }}  
                            id={'calendarEntrYm_' + record.id}
                            allowClear={false}
                            value={record.entrYm ? dayjs(record.entrYm) : null}
                            onChange={(_:any, dateStrings:any) => {
                                dispatch(Usr0103p1Action.setEduItem({...record, entrYm : dateStrings}));
                            }}
                            disabled={!common.isAdmin()}
                        />
                    </ConfigProvider>
                )
            },
            {
                title: () => <div style={{ textAlign: 'center' }}>졸업년월</div>,
                dataIndex: 'gradYm',
                key: 'gradYm',
                align: 'center',
                width: 100,
                render: (_:string, record:IEduState, idx:number) => (
                    <ConfigProvider locale={locale}>
                        <DatePicker
                            format={'YYYY-MM'}
                            style={{ width: 100 }}  
                            id={'calendarGradYm_' + record.id}
                            allowClear={false}
                            value={record.gradYm ? dayjs(record.gradYm) : null}
                            onChange={(_:any, dateStrings:any) => {
                                dispatch(Usr0103p1Action.setEduItem({...record, gradYm : dateStrings}));
                            }}
                            disabled={!common.isAdmin()}
                        />
                    </ConfigProvider>
                )
            },
            {
                title: () => <div style={{ textAlign: 'center' }}>학교명</div>,
                dataIndex: 'schNm',
                key: 'schNm',   
                align: 'left',
                width: 190,
                render: (_:string, record:IEduState, idx:number) => (
                    <Space>
                        {common.isAdmin() ? 
                        <Input id={'inputSchNm_' + record.id} name='schNm' autoComplete='new-password' defaultValue={record.schNm} style={{width: 150}} onChange={(e:any) => {
                            dispatch(Usr0103p1Action.setEduItem({...record, schNm : e.currentTarget.value}));
                        }} />
                        :
                        <Input id={'inputSchNm_' + record.id} name='schNm' autoComplete='new-password' defaultValue={record.schNm} style={{width: 150}} readOnly/>
                        }
                    </Space>
                )
            },
            {
                title: () => <div style={{ textAlign: 'center' }}>학과1</div>,
                dataIndex: 'deptNm1',
                key: 'deptNm1',
                align: 'left',
                width: 190,
                render: (_:string, record:IEduState, idx:number) => (
                    <Space>
                        {common.isAdmin() ? 
                        <Input id={'inputDeptNm1_' + record.id} name='deptNm1' autoComplete='new-password' defaultValue={record.deptNm1} style={{width: 150}} onChange={(e:any) => {
                            dispatch(Usr0103p1Action.setEduItem({...record, deptNm1 : e.currentTarget.value}));
                        }} />
                        :
                        <Input id={'inputDeptNm1_' + record.id} name='deptNm1' autoComplete='new-password' defaultValue={record.deptNm1} style={{width: 150}} readOnly/>
                        }
                    </Space>
                )
            },
            {
                title: () => <div style={{ textAlign: 'center' }}>학과2</div>,
                dataIndex: 'deptNm2',
                key: 'deptNm2',
                align: 'left',
                width: 190,
                render: (_:string, record:IEduState, idx:number) => (
                    <Space>
                        {common.isAdmin() ? 
                        <Input id={'inputDeptNm2_' + record.id} name='deptNm2' autoComplete='new-password' defaultValue={record.deptNm2} style={{width: 150}} onChange={(e:any) => {
                            dispatch(Usr0103p1Action.setEduItem({...record, deptNm2 : e.currentTarget.value}));
                        }} />
                        :
                        <Input id={'inputDeptNm2_' + record.id} name='deptNm2' autoComplete='new-password' defaultValue={record.deptNm2} style={{width: 150}} readOnly/>
                        }
                    </Space>
                )
            }];
            return arr;
    }, [eduTpList]);   

    const certColumns = React.useCallback(() => {
        const arr:any = [
            {
                title: () => <div style={{ textAlign: 'center' }}>취득일자</div>,
                dataIndex: 'certDt',
                key: 'certDt',
                align: 'center',
                width: 120,
                render: (_:string, record:ICertState) => (
                    <ConfigProvider locale={locale}>
                        <DatePicker
                            format={'YYYY-MM-DD'}
                            style={{ width: 120 }}  
                            id={'calendarCertDt_' + record.id}
                            allowClear={false}
                            value={record.certDt ? dayjs(record.certDt) : null}
                            onChange={(_:any, dateStrings:any) => {
                                dispatch(Usr0103p1Action.setCertItem({...record, certDt : dateStrings}));
                            }}
                            disabled={!common.isAdmin()}
                        />
                    </ConfigProvider>
                )
            },
            {
                title: () => <div style={{ textAlign: 'center' }}>자격증</div>,
                dataIndex: 'certTpCd',
                key: 'certTpCd',
                align: 'left',
                width: 500,
                render: (_:string, record:ICertState) => {
                    const handleChange = (item:string) => {
                        dispatch(Usr0103p1Action.setCertItem({...record, certTpCd : item}));
                    }
    
                    const options = certTpList.map(e => {
                        return (<Option key={e.value} value={e.value}>{e.label}</Option>);
                    });
                    return (
                        <Select disabled={!common.isAdmin()} style={{ width: 390 }} onChange={handleChange} value={record.certTpCd}>{options}</Select>
                    )
                },
            },
            {
                title: () => <div style={{ textAlign: 'center' }}>자격증사본</div>,
                dataIndex: 'orginFileNm',
                key: 'orginFileNm',
                align: 'left',
                width: 250,
                render: (_:string, record:ICertState) => <Button className='link-button' size='small' style={{width: 250, textAlign: 'left'}} onClick={() => {
                    if (record.fileId && record.fileId > 0) {
                        common.downloadFile(record.fileId);
                    }
                }}>{record.orginFileNm}</Button>
            },
            {
                title: () => <div style={{ textAlign: 'center' }}>첨부</div>,
                dataIndex: 'attachFile',
                key: 'attachFile',
                align: 'left',
                width: 50,
                render: (_:string, record:ICertState) => {
                    return (
                        common.isAdmin() ?
                        <Upload
                            {...fileProps}
                            id='btnUpload'
                            name='btnUpload'
                            customRequest={dummyRequest}
                            beforeUpload={(_file: File) => {
                                if (!record.realId || record.realId < 1) {
                                    return false;
                                } else {
                                    return true;
                                }
                            }}
                            >
                            <Button size='small' icon={<UploadOutlined/>} onClick={(e:any) => {
                                if (!record.realId || record.realId < 1) {
                                    e.stopPropagation();
                                    const param = {
                                        title: '위드정보 확인',
                                        contents: '자격증 정보를 먼저 저장하세요.',
                                    };
                                    common.openInfo(param);
                                } else {
                                    attachFileItem = { sourceId: record.realId };
                                }
                            }}>첨부</Button>
                        </Upload> : null
                    )
                },
            }];
            return arr;
    }, []);

    /**
     * 기능 : componentDidMount
     * 설명 : 화면 최초 로드시에 필요한 기능을 구현한다.
     * param : 
     * return : None
     */
     React.useEffect(() => {
        fn_DeptCds();
        setUserStCdList();
        setDutyCdList();
        setPostCdList();
        setEduTpList();
        setCertTpList();

        return () => {
            dispatch(Usr0103p1Action.initState());
        }
    }, []);

    const fn_Search = (empNo:string) => {
        /* 변수선언 및 셋팅 영역 */
        // 입력파라미터
        const requestData = {
            empNo
        };

        /* 트렌젝션 호출 및 결과 셋팅 */
        commonProxy.callAsyncSvc(requestData, {
            txCd: 'TRUSRR0003',
            success: (responseData:any) => {
                const userItems = { ...responseData.userList[0] }
                
                if (userItems.pid) {
                    userItems.pid1 = String(userItems.pid).substring(0, 6);
                    userItems.pid2 = String(userItems.pid).substring(6, 7);
                }
                dispatch(Usr0103p1Action.setMmbrItems({...userItems, leaveDtmSave: userItems.leaveDtm}));
                dispatch(Usr0103p1Action.setEduList(responseData.userEduList));
                dispatch(Usr0103p1Action.setCertList(responseData.userCertList));
            },
        });
    }

    React.useEffect(() => {
        if (!props || common.isEmptyString(props.empNo)) {
            if (userStCdList && userStCdList.length > 0) {
                dispatch(Usr0103p1Action.setMmbrItems({ ...mmbrItems, userStCd : 'A' }));
            }
        }

        if (deptCdList && deptCdList.length > 0 && dutyCdList && dutyCdList.length > 0 && postCdList && postCdList.length > 0 && userStCdList && userStCdList.length > 0) {
            if (props && !common.isEmptyString(props.empNo)) {
                fn_Search(props.empNo);
            }
        }
    }, [deptCdList, dutyCdList, postCdList, userStCdList]);

    React.useEffect(() => {
        if(mmbrItems.userStCd === 'T'){
            dispatch(Usr0103p1Action.setMmbrItems({ ...mmbrItems, leaveDtm : common.isEmptyString(mmbrItems.leaveDtmSave) ? commonDate.maskDate(commonDate.getToday(), 'YYYY-MM-DD') : mmbrItems.leaveDtmSave }));
        } else {
            dispatch(Usr0103p1Action.setMmbrItems({ ...mmbrItems, leaveDtm : null }));
        }
    }, [mmbrItems.userStCd]);


    /************************************************
     * 이벤트 함수 영역
     ************************************************/
    const btnSubDept_onClick = () => {
        const params:any = {};
        params.title = '보조부서';
        params.width = 650
        params.popupId = 'com0113p';
        params.props = {empNo : mmbrItems.empNo, deptCd : mmbrItems.deptCd};
        common.openPopup(params);
    };

    const btnSave_onClick = () => {
        /* 정합성 체크 */
        if (!fn_CheckValidation('save')) {
            return;
        }

        const requestData = {
            ...mmbrItems,
            pid : mmbrItems.pid1 + mmbrItems.pid2,
            userEdus: eduList,
            userCerts: certList,
        };

        commonProxy.callAsyncSvc(requestData, {
            txCd: 'TRUSRS0005',
            success: (responseData:any) => {
                
                const userItems = { ...responseData.userItems }
                fn_Search(userItems.empNo);
                const param = {
                    title : '위드정보 확인',
                    contents: '정상적으로 처리되었습니다.',
                };

                common.openAlert(param);
            },
        });
    };

    const btnClose_onClick = () => {
        props.cancel();
    }

     const calendar_onChange_joinDt = (_:any, dateStrings:any) => {
        dispatch(Usr0103p1Action.setMmbrItems({ ...mmbrItems, joinDt : dateStrings }));
   };

     const calendar_onChange_leaveDtm = (_:any, dateStrings:any) => {
        dispatch(Usr0103p1Action.setMmbrItems({ ...mmbrItems, leaveDtm : dateStrings }));
   };

     const calendar_onChange_realEntDt = (_:any, dateStrings:any) => {
        dispatch(Usr0103p1Action.setMmbrItems({ ...mmbrItems, realEntDt : dateStrings }));
   };

     const calendar_onChange_birdDt = (_:any, dateStrings:any) => {
        dispatch(Usr0103p1Action.setMmbrItems({ ...mmbrItems, birdDt : dateStrings }));
   };

    const btnReset_onClick = React.useCallback(() => {
        dispatch(Usr0103p1Action.initState());
    }, []);

    const onClick = async (e:any, _record:any) => {
        const buttonName = e.currentTarget.name;
        switch (buttonName) {
            case 'btnSubDept': {
                btnSubDept_onClick();
                break;
            }
            case 'btnReset': {
                btnReset_onClick();
                break;
            }
            case 'btnSave': {
                btnSave_onClick();
                break;
            }
            case 'btnClose': {
                btnClose_onClick();
                break;
            }
            case 'addEdu': {
                if (!eduList || eduList.length < 1) {
                    dispatch(Usr0103p1Action.setEduList([{id: 1}]));
                } else {
                    let id = 0;
                    let tmpArr = [...eduList];
                    for (let i = 0; i < eduList.length; i++) {
                        id = eduList[i].id;
                    }

                    tmpArr.push({id : ++id});
                    dispatch(Usr0103p1Action.setEduList(tmpArr));
                }
                break;
            }
            case 'minusEdu': {
                if (!selectedEduRowKeys || selectedEduRowKeys.length < 1) return;
                dispatch(Usr0103p1Action.removeEduItems(selectedEduRowKeys));
                break;
            }
            case 'addCert': {
                if (!certList || certList.length < 1) {
                    dispatch(Usr0103p1Action.setCertList([{id: 1}]));
                } else {
                    let id = 0;
                    let tmpArr = [...certList];
                    for (let i = 0; i < certList.length; i++) {
                        id = certList[i].id;
                    }

                    tmpArr.push({id : ++id});
                    dispatch(Usr0103p1Action.setCertList(tmpArr));
                }
                break;
            }
            case 'minusCert': {
                if (!selectedCertRowKeys || selectedCertRowKeys.length < 1) return;
                dispatch(Usr0103p1Action.removeCertItems(selectedCertRowKeys));
                break;
            }
            default:
        }
    };

    /************************************************
     * 개발자함수 영역
     ************************************************/
     const fn_CheckValidation = (tran_div:string) => {
        let result = true;

        if(mmbrItems.userId !== 'admin'){
            if (tran_div === 'save') {
                let result = true;
                if(!common.isEmptyString(mmbrItems.newPswd) || !common.isEmptyString(mmbrItems.chkPswd)){
                    if(mmbrItems.newPswd !== mmbrItems.chkPswd){
                        const param = {
                            title : '위드정보 확인',
                            contents: '비밀번호 확인이 일치하지 않습니다.',
                        };
                        common.openInfo(param);
                        return false;
                    }
                }

                if(common.isEmptyString(mmbrItems.userId)) {
                    const param = {
                        title : '위드정보 확인',
                        contents: '사용자ID는 필수입력 항목입니다.',
                    };
                    common.openInfo(param);
                    return false;
                }

                if(common.isEmptyString(mmbrItems.userNm)) {
                    const param = {
                        title : '위드정보 확인',
                        contents: '사용자명은 필수입력 항목입니다.',
                    };
                    common.openInfo(param);
                    return false;
                }

                if(common.isEmptyString(mmbrItems.joinDt)) {
                    const param = {
                        title : '위드정보 확인',
                        contents: '입사일자는 필수입력 항목입니다.',
                    };
                    common.openInfo(param);
                    return false;
                }

                if(common.isEmptyString(mmbrItems.deptCd)) {
                    const param = {
                        title : '위드정보 확인',
                        contents: '부서는 필수입력 항목입니다.',
                    };
                    common.openInfo(param);
                    return false;
                }

                if(common.isEmptyString(mmbrItems.dutyCd)) {
                    const param = {
                        title : '위드정보 확인',
                        contents: '직책은 필수입력 항목입니다.',
                    };
                    common.openInfo(param);
                    return false;
                }

                if(common.isEmptyString(mmbrItems.postCd)) {
                    const param = {
                        title : '위드정보 확인',
                        contents: '직위는 필수입력 항목입니다.',
                    };
                    common.openInfo(param);
                    return false;
                }

                if (common.isEmptyString(mmbrItems.userEmail)) {
                    const param = {
                        title : '위드정보 확인',
                        contents: '이메일은 필수입력 항목입니다.',
                    };
                    common.openInfo(param);
                    return false;
                }

                const checkHan = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/;
                if (mmbrItems.userEmail && (!validator.isEmail(mmbrItems.userEmail) || checkHan.test(mmbrItems.userEmail))) {
                    const param = {
                        title : '위드정보 확인',
                        contents: '이메일 형식을 확인하세요.',
                    };
                    common.openInfo(param);
                    return false;
                }

                const mobileNo1 = mmbrItems.mobileNo ? mmbrItems.mobileNo : '';
                const mobileNo2 = mmbrItems.mobileNo ? mmbrItems.mobileNo.replace(/-/gi, '') : '';
                if (!mmbrItems.mobileNo) {
                    const param = {
                        title : '위드정보 확인',
                        contents: '휴대전화는 필수입력 항목입니다.',
                    };
                    common.openInfo(param);
                    return false;
                }

                if (mobileNo1.indexOf('-') !== -1 && mobileNo1.split('-').length !== 3) {
                    const param = {
                        title : '위드정보 확인',
                        contents: '휴대전화 형식을 확인하세요.',
                    };
                    common.openInfo(param);
                    return false;
                }

                if (mobileNo2.length !== 10 && mobileNo2.length !== 11) {
                    const param = {
                        title : '위드정보 확인',
                        contents: '휴대전화 형식을 확인하세요.',
                    };
                    common.openInfo(param);
                    return false;
                }

                /* 학력 */
                if (eduList && eduList.length > 0) {
                    let filterd = null;
                    for (let i = 0; i < eduList.length; i++) {
                        filterd = eduList.filter(e => {
                            return e.eduTpCd === eduList[i].eduTpCd && e.gradYm.replace(/-/gi, '') === eduList[i].gradYm.replace(/-/gi, '')
                        });

                        if (filterd && filterd.length > 1) {
                            result = false;
                            const param = {
                                title : '위드정보 확인',
                                contents: '중복된 학력정보가 있습니다.',
                            };
                            common.openInfo(param);
                            return result
                        }
                    }
                }

                /* 자격증 */
                if (certList && certList.length > 0) {
                    let filterd = null;
                    for (let i = 0; i < certList.length; i++) {
                        filterd = certList.filter(e => {
                            return e.certTpCd === certList[i].certTpCd
                        });

                        if (filterd && filterd.length > 1) {
                            result = false;
                            const param = {
                                title : '위드정보 확인',
                                contents: '중복된 자격증정보가 있습니다.',
                            };
                            common.openInfo(param);
                            return result
                        }
                    }
                }

                return result
            }
        }

        return result;
    }

    /************************************************
     * 파일업로드 관련 영역
     ************************************************/
    const dummyRequest = ({_, onSuccess }:any) => {
        setTimeout(() => {
            onSuccess('ok');
        }, 0);
    };

     const requestUploadFiles = (attachFileItem:any, file:any) => {
        common.uploadFile([file], {
            sourceDcd: '03',
            sourceId: attachFileItem.sourceId,
            success: (response:any) => {
                const param = {
                    title : '위드정보 확인',
                    contents: '자격증 사본이 업로드 되었습니다.',
                    accept: () => {
                        const uploadItem = response.fileItems[0];
                        const idx = certList.findIndex(e => e.id === uploadItem.sourceId);
                        const item = { ...certList[idx], id : uploadItem.sourceId,  fileId: uploadItem.id, orginFileNm: uploadItem.orginFileNm };
                        console.log(item);
                        dispatch(Usr0103p1Action.setCertItem(item));
                    }
                };

                common.openAlert(param);
            },
        });
    }

     const selectFile_onChange = (info:any) => {
        switch (info.file.status) {
            case 'done':
                const grdFile = {fileNm : info.file.originFileObj.name, orginFileNm : info.file.originFileObj.name};
                requestUploadFiles({ ...attachFileItem, ...grdFile }, info.file.originFileObj);
                break;

            default:
                break;
        }
    }

    /* File Upload Options */
    const fileProps = {
        onChange: selectFile_onChange,
        multiple: false,
        showUploadList: false,
    };

    // 우편번호 찾기 번튼 클릭(팝업Open)
    const addrSearch = () => {
        setAddrType('USER');
    }

    const dlvAddrSearch = () => {
        setAddrType('DLV');
    }

    // 우편번호 선택 완료
    const handleComplete = (data:any) => {
        // 주소 셋팅
        dispatch(Usr0103p1Action.setMmbrItems({ ...mmbrItems, userPostNo : data.zonecode, userAddr : data.address }));
        setAddrType('');
    }

    const handleDlvAddrComplete = (data:any) => {
        // 주소 셋팅
        dispatch(Usr0103p1Action.setMmbrItems({ ...mmbrItems, userDlvPostNo : data.zonecode, userDlvAddr : data.address }));
        setAddrType('');
    }

    const eduRowSelection = {
        onChange: (selectedRowKeys:any) => {
            dispatch(Usr0103p1Action.setSelectedEduRowKeys(selectedRowKeys));
        },
    };

    const certRowSelection = {
        onChange: (selectedRowKeys:any) => {
            dispatch(Usr0103p1Action.setSelectedCertRowKeys(selectedRowKeys));
        },
    };


    return (
        /* 화면 디자인 영역*/
        <Layout>
            <Content>
                <Space direction='vertical' size='middle'>
                    <Descriptions bordered column={2} size='small'>
                        <Descriptions.Item label='사용자ID' labelStyle={{width:110}}>
                            <Input id='inputUserId' name='userId' autoComplete='new-password' style={{width:250}} value={mmbrItems.userId} disabled={!common.isEmptyString(mmbrItems.empNo)} onChange={(e:any) => {
                                dispatch(Usr0103p1Action.setMmbrItems({ ...mmbrItems, userId : e.currentTarget.value }));
                            }}/>
                        </Descriptions.Item>
                        <Descriptions.Item label='이름' labelStyle={{width:110}}>
                            <Space>
                                <Input id='inputUserNm' name='userNm' autoComplete='new-password' value={mmbrItems.userNm} disabled={!common.isAdmin()} style={{width:120}} onChange={(e:any) => {
                                    dispatch(Usr0103p1Action.setMmbrItems({ ...mmbrItems, userNm : e.currentTarget.value }));
                                }}/>
                                <Switch id='swGndrTpCd' checkedChildren='여자' unCheckedChildren='남자' disabled={!common.isAdmin()} checked={mmbrItems.gndrTpCd === '02'} onChange={(isChecked:boolean) => {
                                    dispatch(Usr0103p1Action.setMmbrItems({ ...mmbrItems, gndrTpCd : isChecked ? '02' : '01'}));
                                }}/>
                            </Space>
                        </Descriptions.Item>
                        <Descriptions.Item label='상태'>
                            <Select 
                                showSearch
                                style={{
                                    width: 80,
                                }}
                                optionFilterProp='label'
                                defaultValue=''
                                options={userStCdList}
                                value={mmbrItems.userStCd}
                                onChange={val => dispatch(Usr0103p1Action.setMmbrItems({...mmbrItems, userStCd: val}))}
                                {...common.getReadonlySelectboxProps(!common.isAdmin() || common.isEmptyString(mmbrItems.empNo))}
                            ></Select>
                        </Descriptions.Item>
                        <Descriptions.Item label='입사일자'>
                            <ConfigProvider locale={locale}>
                                <DatePicker
                                    inputReadOnly
                                    disabled={!common.isAdmin()}
                                    allowClear={false}
                                    value={common.isEmptyString(mmbrItems.joinDt) ? dayjs(commonDate.maskDateDefault(commonDate.getToday())) : dayjs(mmbrItems.joinDt)}
                                    onChange={calendar_onChange_joinDt}/> 
                            </ConfigProvider>
                        </Descriptions.Item>
                        <Descriptions.Item label='실입사일'>
                            <ConfigProvider locale={locale}>
                                <DatePicker
                                    inputReadOnly
                                    disabled={!common.isAdmin()}
                                    allowClear={false}
                                    value={common.isEmptyString(mmbrItems.realEntDt) ? null : dayjs(mmbrItems.realEntDt)}
                                    onChange={calendar_onChange_realEntDt}/>
                            </ConfigProvider>
                        </Descriptions.Item>
                        <Descriptions.Item label='퇴사일자'>
                            {mmbrItems.userStCd === 'T' ? 
                            <ConfigProvider locale={locale}>
                                <DatePicker
                                    inputReadOnly
                                    disabled={!common.isAdmin()}
                                    allowClear={false}
                                    value={dayjs(mmbrItems.leaveDtm)}
                                    onChange={calendar_onChange_leaveDtm}/>
                            </ConfigProvider> : '재직중'}
                        </Descriptions.Item>
                        <Descriptions.Item label='부서'>
                            <Space size='small'>
                                <Select 
                                    showSearch
                                    style={{
                                        width: 150,
                                    }}
                                    optionFilterProp='label'
                                    defaultValue=''
                                    options={deptOptions()}
                                    value={mmbrItems.deptCd}
                                    onChange={val => dispatch(Usr0103p1Action.setMmbrItems({...mmbrItems, deptCd : val}))}
                                    {...common.getReadonlySelectboxProps(!common.isAdmin())}
                                ></Select>
                                <Button name='btnSubDept' className='background-color-default-button' onClick={(e:any) => onClick(e, null)}>보조부서</Button>
                            </Space>
                        </Descriptions.Item>
                        <Descriptions.Item label='직위'>
                            <Select 
                                showSearch
                                style={{
                                    width: 100,
                                }}
                                optionFilterProp='label'
                                defaultValue=''
                                options={postCdList}
                                value={mmbrItems.postCd}
                                onChange={val => dispatch(Usr0103p1Action.setMmbrItems({...mmbrItems, postCd: val}))}
                                {...common.getReadonlySelectboxProps(!common.isAdmin())}
                            ></Select>
                        </Descriptions.Item>
                        <Descriptions.Item label='직책'>
                            <Space>
                                <Select 
                                    showSearch
                                    style={{
                                        width: 100,
                                    }}
                                    optionFilterProp='label'
                                    defaultValue=''
                                    options={dutyCdList}
                                    value={mmbrItems.dutyCd}
                                    onChange={val => dispatch(Usr0103p1Action.setMmbrItems({...mmbrItems, dutyCd: val}))}
                                    {...common.getReadonlySelectboxProps(!common.isAdmin())}
                                ></Select>
                                    <Switch id='swDeptHdrYn' checkedChildren='부서장' unCheckedChildren='부서원' disabled={!common.isAdmin()} checked={mmbrItems.deptHdrYn === 'Y'} onChange={(isChecked) => {
                                        dispatch(Usr0103p1Action.setMmbrItems({ ...mmbrItems, deptHdrYn : isChecked ? 'Y' : 'N'}));
                                    }}/>
                            </Space>
                        </Descriptions.Item>
                        <Descriptions.Item label='생년월일'>
                            <Space>
                                <ConfigProvider locale={locale}>
                                    <DatePicker
                                        inputReadOnly
                                        disabled={!common.isAdmin()}
                                        allowClear={false}
                                        value={common.isEmptyString(mmbrItems.birdDt) ? null : dayjs(mmbrItems.birdDt)}
                                        onChange={calendar_onChange_birdDt}/>
                                </ConfigProvider>
                                <Switch id='swBirdTpCd' checkedChildren='음력' unCheckedChildren='양력' disabled={!common.isAdmin()} checked={mmbrItems.birdTpCd === '02'} onChange={(isChecked) => {
                                    dispatch(Usr0103p1Action.setMmbrItems({ ...mmbrItems, birdTpCd : isChecked ? '02' : '01'}));
                                }}/>
                            </Space>
                        </Descriptions.Item>
                        <Descriptions.Item label='주민번호'>
                            <Space>
                                <Input id='inputPid1' name='pid1' autoComplete='new-password' value={mmbrItems.pid1} maxLength={6} disabled={!common.isAdmin()} style={{width: 80}} onChange={(e:any) => {
                                    const { value: inputValue } = e.currentTarget;
                                    const reg = /^[0-9]+$/;
                                    if (reg.test(inputValue) || inputValue === '') {
                                        dispatch(Usr0103p1Action.setMmbrItems({ ...mmbrItems, pid1 : e.currentTarget.value }));
                                    }
                                }}/>
                                -
                                <Input id='inputPid2' name='pid2' autoComplete='new-password' value={mmbrItems.pid2} maxLength={1} disabled={!common.isAdmin()} style={{width: 30}} onChange={(e:any) => {
                                    const { value: inputValue } = e.currentTarget;
                                    const reg = /^[0-9]+$/;
                                    if (reg.test(inputValue) || inputValue === '') {
                                        dispatch(Usr0103p1Action.setMmbrItems({ ...mmbrItems, pid2 : e.currentTarget.value }));
                                    }
                                }}/>
                                <Switch id='swMilCmpltYn' checkedChildren='군필' unCheckedChildren='미필' disabled={!common.isAdmin()} checked={mmbrItems.milCmpltYn === 'Y'} onChange={(isChecked) => {
                                    dispatch(Usr0103p1Action.setMmbrItems({ ...mmbrItems, milCmpltYn : isChecked ? 'Y' : 'N'}));
                                }}/>
                            </Space>
                        </Descriptions.Item>
                        <Descriptions.Item label='휴대전화'>
                            <Input id='inputMobileNo' name='mobileNo' autoComplete='new-password' value={mmbrItems.mobileNo} onChange={e => { dispatch(Usr0103p1Action.setMmbrItems({ ...mmbrItems, mobileNo : e.currentTarget.value })) }}/>
                        </Descriptions.Item>
                        <Descriptions.Item label='이메일' span={2}>
                            <Input id='inputUserEmail' name='userEmail' autoComplete='new-password' value={mmbrItems.userEmail} onChange={e => { dispatch(Usr0103p1Action.setMmbrItems({ ...mmbrItems, userEmail : e.currentTarget.value })) }}/>
                        </Descriptions.Item>
                        <Descriptions.Item label='주소' span={2}>
                            <Row>
                                <Col>
                                    <Space>
                                        <Search id='userPostNo' autoComplete='new-password' style={{width : '130px'}} placeholder='우편번호' readOnly onSearch={addrSearch} value={mmbrItems.userPostNo} enterButton title='우편번호'/>
                                        {addrType === 'USER' && (
                                            <DaumPost onComplete={handleComplete} />
                                        )} 
                                        <Input readOnly autoComplete='new-password' value={mmbrItems.userAddr} style={{width : '300px'}}/>
                                        <Input name='userDtlAddr' autoComplete='new-password' placeholder='상세주소' style={{width : '355px'}} value={mmbrItems.userDtlAddr} maxLength={500} title='상세주소' onChange={e => { dispatch(Usr0103p1Action.setMmbrItems({ ...mmbrItems, userDtlAddr : e.currentTarget.value })) }}/>
                                    </Space>
                                </Col>
                                <Col>
                                </Col>
                            </Row>
                        </Descriptions.Item>
                        <Descriptions.Item label='배송지주소' span={2}>
                            <Row>
                                <Col>
                                    <Space>
                                        <Search id='userDlvPostNo' autoComplete='new-password' style={{width : '130px'}} placeholder='우편번호' readOnly onSearch={dlvAddrSearch} value={mmbrItems.userDlvPostNo} enterButton title='우편번호'/>
                                        {addrType === 'DLV' && (
                                            <DaumPost onComplete={handleDlvAddrComplete} />
                                        )} 
                                        <Input readOnly autoComplete='new-password' value={mmbrItems.userDlvAddr} style={{width : '300px'}}/>
                                        <Input name='userDlvDtlAddr' autoComplete='new-password' placeholder='상세주소' style={{width : '355px'}} value={mmbrItems.userDlvDtlAddr} maxLength={500} title='상세주소' onChange={e => { dispatch(Usr0103p1Action.setMmbrItems({ ...mmbrItems, userDlvDtlAddr : e.currentTarget.value })) }}/>
                                    </Space>
                                </Col>
                                <Col>
                                </Col>
                            </Row>
                        </Descriptions.Item>
                        <Descriptions.Item label='현비밀번호'>
                            <Input.Password id='inputOldPswd' autoComplete='off' readOnly placeholder='input password' name='inputOldValue' value={mmbrItems.oldPswd} onFocus={(e:any) => { e.currentTarget.removeAttribute('readonly'); }} onChange={e => { dispatch(Usr0103p1Action.setMmbrItems({ ...mmbrItems, oldPswd : e.currentTarget.value })) }}/>
                        </Descriptions.Item>
                        <Descriptions.Item label='새비밀번호'>
                            <Row>
                                <Col>
                                    <Input.Password id='inputNewPswd' autoComplete='off' readOnly placeholder='input password' name='inputNewValue' value={mmbrItems.newPswd} onFocus={(e:any) => { e.currentTarget.removeAttribute('readonly'); }} onChange={e => { dispatch(Usr0103p1Action.setMmbrItems({ ...mmbrItems, newPswd : e.currentTarget.value })) }}/>
                                </Col>
                                <Col>
                                    <Input.Password id='inputChkPswd' autoComplete='off' readOnly placeholder='input password' name='inputChkValue'  value={mmbrItems.chkPswd} onFocus={(e:any) => { e.currentTarget.removeAttribute('readonly'); }} onChange={e => { dispatch(Usr0103p1Action.setMmbrItems({ ...mmbrItems, chkPswd : e.currentTarget.value })) }}/>
                                </Col>
                            </Row>
                        </Descriptions.Item>
                    </Descriptions>
                    
                    <Collapse
                            bordered={false}
                            defaultActiveKey={['0']}
                            expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 0} />}
                            className='site-collapse-custom-collapse'>
                        <Panel header='기타정보' key='1' className='site-collapse-custom-panel'>
                            <Row align='middle' style={{ height: 50 }}>
                                <Col flex='9.5'>
                                    <Space>
                                        <img className='title-icon' alt='' />
                                        <Text strong>학력정보</Text>
                                    </Space>
                                </Col>
                                {common.isAdmin() ?
                                <Col flex='0.5'>
                                    <Space>
                                        <Button name='addEdu' size='small'   onClick={(e:any) => onClick(e, null)} icon={<PlusOutlined/>}/>
                                        <Button name='minusEdu' size='small' onClick={(e:any) => onClick(e, null)} icon={<MinusOutlined/>}/>
                                    </Space>
                                </Col> : null}
                            </Row>
                            <Table
                                dataSource={eduList}
                                key='eduList'
                                rowKey='id'
                                columns={eduColumns()}
                                size='small'
                                style={{width:'500'}}
                                scroll={{x:150}}
                                pagination={false}
                                rowSelection={{
                                    type: 'checkbox',
                                    ...eduRowSelection,
                                }}
                            />
                            <Row align='middle' style={{ height: 50 }}>
                                <Col flex='9.5'>
                                    <Space>
                                        <img className='title-icon' alt='' />
                                        <Text strong>자격증 취득현황</Text>
                                    </Space>
                                </Col>
                                {common.isAdmin() ?
                                <Col flex='0.5'>
                                    <Space>
                                        <Button name='addCert'   size='small' onClick={(e:any) => onClick(e, null)} icon={<PlusOutlined/>}/>
                                        <Button name='minusCert' size='small' onClick={(e:any) => onClick(e, null)} icon={<MinusOutlined/>}/>
                                    </Space>
                                </Col> : null}
                            </Row>
                            <Table
                                dataSource={certList}
                                key='certList'
                                rowKey='id'
                                columns={certColumns()}
                                size='small'
                                style={{width:'500'}}
                                scroll={{x:150}}
                                pagination={false}
                                rowSelection={{
                                    type: 'checkbox',
                                    ...certRowSelection,
                                }}
                            />
                        </Panel>
                    </Collapse>
                </Space>

                <Row justify='center' style={{ marginTop: 20 }}>
                    <Space size='small'>
                        {common.isAdmin() ?
                        <Col>
                            <Button
                                name='btnReset'
                                className='background-color-default-button'
                                onClick={(e:any) => onClick(e, null)}
                            >
                                초기화
                            </Button>
                        </Col> : null}
                        {common.isAdmin() || mmbrItems.empNo === common.getEmpNo() ?
                        <Col>
                        <Button
                            name='btnSave'
                            className='background-color-primary-button'
                            onClick={(e:any) => onClick(e, null)}
                        >
                            저장
                            </Button>
                        </Col> : null}
                        <Col>
                        <Button
                            name='btnClose'
                            className='background-color-default-button'
                            onClick={(e:any) => onClick(e, null)}
                        >
                            닫기
                        </Button>
                        </Col>
                    </Space>
                </Row>
            </Content>
        </Layout>
    );
}

export default Usr0103p1;